


export class MsPermissionService {



    private static uid: string = localStorage.getItem('uid') ?? '';

    public static isInternalUserPM(internalPm: any) {
        if (internalPm) {
            if (Array.isArray(internalPm) && internalPm.length > 0) {
                return this.uid === internalPm[0]._id;
            } else if (typeof internalPm === 'object' && internalPm._id) {
                return this.uid === internalPm._id;
            } else if (typeof internalPm == 'string') {
                return this.uid === internalPm;
            }
        }
        return false;
    }


    public static isVendorUser(project: any) {
        return project.vendor.some((vendor: any) => vendor._id == this.uid);
    }

    public static checkUserPermissions(project: any) {
        if (project.vendor.includes(this.uid)) {
            return false;
        } else if (project.internalPm == this.uid) {
            return true;
        } else {
            return null;
        };
    }

    public static setProjectPermissions(projects: any[]) {
        projects = projects.map(project => {
            if (MsPermissionService.isVendorUser(project)) {
                project.role = "vendor"
            } else if (MsPermissionService.isInternalUserPM(project.internalPm)) {
                project.role = "pm"
            }
            return project;
        })

        return projects;
    }
}